'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _aphrodite = require('aphrodite');

exports.default = _aphrodite.StyleSheet.create({
  div: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    boxSizing: 'border-box',
    minHeight: 0,
    minWidth: 0
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@zhike/ti-ui/lib/view/styles.js
// module id = 443
// module chunks = 0